// material
import { Card, Typography, Box } from "@material-ui/core";
import { alpha, styled } from "@material-ui/core/styles";
import { DonutLarge } from "@material-ui/icons";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
	boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	borderRadius: "10px",
	textAlign: "center",
	// padding: theme.spacing(5, 0),
	color: theme.palette.warning.dark,
	backgroundColor: theme.palette.warning.light,
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
	margin: "auto",
	display: "flex",
	borderRadius: "50%",
	alignItems: "center",
	width: theme.spacing(6),
	height: theme.spacing(6),
	justifyContent: "center",
	marginBottom: theme.spacing(3),
	color: theme.palette.warning.dark,
	backgroundImage: `linear-gradient(135deg, ${alpha(
		theme.palette.warning.dark,
		0
	)} 0%, ${alpha(theme.palette.warning.dark, 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

export default function onProgress({ onProgress }) {
	return (
		<RootStyle>
			<IconWrapperStyle>
				<DonutLarge width={24} height={24} />
			</IconWrapperStyle>
			<Typography variant="h3">{fShortenNumber(onProgress?.total)}</Typography>
			<Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
				On Progress
			</Typography>
			<Box
				style={{
					display: "flex",
					height: "10vh",
					backgroundColor: "#FFC107",
					fontSize: "20px",
				}}
			>
				<span
					style={{
						display: "flex",
						justifyContent: "space-around",
						width: "100%",
						alignItems: "center",
						fontWeight: "bold",
						color: "#fff",
					}}
				>
					<p>
						{onProgress?.late_data?.bulan} : {onProgress?.late_data?.jumlah}
					</p>
					<p>
						{onProgress?.current_data?.bulan} :
						{onProgress?.current_data?.jumlah}
					</p>
				</span>
			</Box>
		</RootStyle>
	);
}
